export const mediaUrl = (file) => {
  return `https://storage.googleapis.com/${process.env.REACT_APP_STORAGE_BUCKET}/${file}`
}
